export const topHeaderText = ['pedibello', 'gabinet podologiczny', 'urszula piekarska']
export const bottomHeaderText = ['profesjonalizm, gwarancja sterylności i bezpieczeństwa wykonywanych usług']